import { useState, useEffect } from "react";
import { Box, Tabs, Tab, Paper, Button } from "@mui/material";

import useClientInvoice from "../../hooks/useClientInvoice";
import useThirdPartyInvoice from "../../hooks/useThirdPartyInvoice";

import Page from "./Page";
import ClientInvoicesList from "../invoicing/ClientInvoicesList";
import ThirdPartyInvoicesList from "../invoicing/ThirdPartyInvoicesList";
import VendorsCategoriesPanel from "../invoicing/VendorsCategoriesPanel";
import BulkGenerateDialog from "../invoicing/BulkGenerateDialog";

const InvoicingPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [openBulkGenerate, setOpenBulkGenerate] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { getInvoices } = useClientInvoice();
  const { getInvoices: getThirdPartyInvoices } = useThirdPartyInvoice();

  useEffect(() => {
    loadData();
  }, [refreshTrigger]);

  const loadData = async () => {
    await getInvoices();
    await getThirdPartyInvoices();
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleRefresh = async () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleToolbarClick = (action) => {
    if (action === "refresh") {
      handleRefresh();
    }
  };

  return (
    <Page
      pageName="invoicing"
      includeToolbar={true}
      onToolItemClick={handleToolbarClick}
    >
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <Box
          display="flex"
          justifyContent="flex-end"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenBulkGenerate(true)}
          >
            Generate Monthly Invoices
          </Button>
        </Box>

        <Paper sx={{ display: "flex", flexDirection: "column" }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            sx={{ borderBottom: "1px solid #ddd" }}
          >
            <Tab label="Client Invoices" />
            <Tab label="Third-Party Invoices" />
            <Tab label="Vendors & Categories" />
          </Tabs>

          <Box
            flex={1}
            padding={2}
            overflow="auto"
          >
            {tabIndex === 0 && (
              <ClientInvoicesList refreshTrigger={refreshTrigger} />
            )}
            {tabIndex === 1 && (
              <ThirdPartyInvoicesList refreshTrigger={refreshTrigger} />
            )}
            {tabIndex === 2 && (
              <VendorsCategoriesPanel refreshTrigger={refreshTrigger} />
            )}
          </Box>
        </Paper>
      </Box>

      <BulkGenerateDialog
        open={openBulkGenerate}
        onClose={() => setOpenBulkGenerate(false)}
        onGenerated={handleRefresh}
      />
    </Page>
  );
};

export default InvoicingPage;
